import { useDealership } from '@/contexts/DealershipContext'
import { Group, Stack, Text, Title } from '@mantine/core'
import { RecoveryStatusCard } from './components/RecoveryStatusCard'

export function ActivitiesDashboard() {
  const { selectedEntity } = useDealership()

  if (!selectedEntity || selectedEntity.type !== 'dealership') {
    return <Text>Please select a dealership</Text>
  }

  // const dealership = selectedEntity as Dealership

  return (
    <Stack gap="md">
      {/* Header */}
      <Group justify="space-between">
        <div>
          <Title order={2}>Activity Dashboard</Title>
          <Text size="sm" c="dimmed">
            Monitor workflow status performance
          </Text>
        </div>
      </Group>

      {/* Recovery Status */}
      <RecoveryStatusCard />

    </Stack>
  )
}
